import React, { createContext } from "react";
import { tacticalCategoryPageRecords } from "@search-app/utilities/tacticalCategory";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var TacticalCategoryContext = /*#__PURE__*/createContext({
  tacticalCategory: null,
  isSearchResultsHidden: false
});
export var TacticalCategoryContextProvider = function TacticalCategoryContextProvider(_ref) {
  var _Object$values$find;

  var isSearchResultsHidden = _ref.isSearchResultsHidden,
      isTacticalCategoryPage = _ref.isTacticalCategoryPage,
      slug = _ref.slug,
      children = _ref.children;
  var tacticalCategory = !isTacticalCategoryPage ? null : (_Object$values$find = Object.values(tacticalCategoryPageRecords).find(function (_ref2) {
    var pathPattern = _ref2.pathPattern;
    return pathPattern.test(slug);
  })) !== null && _Object$values$find !== void 0 ? _Object$values$find : null;
  return ___EmotionJSX(TacticalCategoryContext.Provider, {
    value: {
      isSearchResultsHidden: isSearchResultsHidden,
      tacticalCategory: tacticalCategory
    }
  }, children);
};